module.exports = __webpack_public_path__ + "static/grilled-cheese-7de0ee5b7d94bf0cf76632ed248fc15c.woff";